import { render, staticRenderFns } from "./filterSuggestion.vue?vue&type=template&id=314487eb&"
import script from "./filterSuggestion.vue?vue&type=script&lang=js&"
export * from "./filterSuggestion.vue?vue&type=script&lang=js&"
import style0 from "./filterSuggestion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports